import { GLServiceBase, ServiceRoute } from "commonui";
import { CreateActivityRequestModel, ITeachingActivityService, TeachingActivityModel } from ".";

class TeachingActivityServiceClass extends GLServiceBase<any, any> implements ITeachingActivityService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/teachingactivitise" };

	getTeachingActivitiesStatistic(params: any): Promise<any> {
		return this.get("statistic", params);
	}

	createTeachingActivity(params: any): Promise<any> {
		return this.create(params);
	}

	updateTeachingActivity(params: any): Promise<any> {
		return this.update(params);
	}

	deleteTeachingActivity(params: any): Promise<any> {
		return this.delete("{teachingActivityId}", params);
	}

	createMultipleTeachingActivity(
		params: CreateActivityRequestModel[]
	): Promise<{ item1: TeachingActivityModel[]; item2: string[] }> {
		return this.create("multiple", params, undefined);
	}
}

export const TeachingActivityService = () => new TeachingActivityServiceClass();
